/* External Imports */
import { Box, Flex, Text } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import TestimonialCard from '@components/UI/YantraCeremony/TestimonialCard';

/**
 * Renders Participant Exp Component
 * @description Renders the ParticipantExp component
 * @param {Array} participantData
 * @returns {ReactElement} Participant Exp component
 */
const ParticipantExp = ({ participantData }) => {
  return (
    <>
      <Box bgColor="#FFF7E2">
        <Box
          maxWidth={{ base: '100%', md: '998px', lg: '1120px' }}
          fontFamily="FedraSansStd-A-medium"
          mx="auto"
          padding={{
            base: '50px 30px 0',
            md: '100px 10px 0',
          }}
        >
          <Text
            fontSize={{ base: '16px', md: '22px' }}
            color="#705D2B"
            textAlign="center"
            fontFamily="FedraSansStd-Book"
          >
            {participantData[0].title[0].titleText}
          </Text>
          <Text
            fontSize={{ base: '27', md: '40px' }}
            textAlign="center"
            mb={{ base: '30px', md: '50px' }}
            lineHeight="34px"
            px={{ base: '30px', md: '0' }}
          >
            {participantData[0].title[0].titleSubtext}
          </Text>
          <Box
            maxWidth={{ base: '', md: '998px', lg: '1120px' }}
            mx="auto"
            padding={{ base: '0' }}
            fontFamily="FedraSansStd-book"
            mb={{ base: '0', small: '0', md: '20px' }}
          >
            <Flex
              flexDir={{ base: 'column', md: 'row' }}
              w="100%"
              fontFamily="FedraSansStd-book-i"
            >
              <TestimonialCard cardData={participantData[0].testimonials} />
            </Flex>
          </Box>
          {/* <Box
            maxWidth={{ base: '', md: '998px', lg: '1120px' }}
            mx="auto"
            position="relative"
            zIndex="2"
          >
            <Box bgColor="#fff" height="1190px" mb="40px">
              <a name="enquirynow" />
              <Box textAlign="center">
                <Box
                  as="h2"
                  fontFamily="FedraSansStd-A-medium, sans-serif"
                  fontSize={{ lg: '40px', base: '27px' }}
                  textAlign="center"
                  fontWeight="normal"
                >
                  {participantData[2].titleText}
                </Box>
                <Image
                  src={`${config.imgPath}/d/46272/1656740172-yantra_sectiontitle_flower.png`}
                  // src={`https://images.sadhguru.org/d/46272/1656740172-yantra_sectiontitle_flower.png`}
                  m="20px auto"
                />
              </Box>
              <Box
                as="iframe"
                frameBorder="0"
                width="100%"
                allowFullScreen
                height="100%"
                className="enquiryform"
                background="none"
                src="https://forms.zohopublic.in/itappswebaccounts/form/YantraCeremony/formperma/08oT5plge0ct1_vly39awK2P5j6P7DFSSrXyJQGB8Ak"
              ></Box>
            </Box>
          </Box> */}
        </Box>
      </Box>
    </>
  );
};

export default ParticipantExp;
